import { getAndSetupWarranties, getWarranties } from 'helpers/api';
import { formatDate, hasClass } from 'helpers/utils';
import { isProd } from 'config/config';

const url = isProd ? `/portal/warranty` : '/warranty.html';

const state = {
    statuses: {},
    images: {},
    warranties: [],
    pagination: {},
    search: {},
    // brands: ['sm', 'mp', 'bs', 'ope', 'sd', 'oep', 'jdna', 'ppe', 'mur', 'daye', 'hyp', 'ocs', 'sd'],
    brands: ['bs', 'bspp', 'day', 'hyp', 'jdna', 'mer', 'mp', 'mur', 'oep', 'ope', 'ppe', 'sd', 'SNP'],
};

// ==================================================
// INITIALIZERS
// ==================================================

async function setState() {
    const { warranties, statusCodes, mfCodes } = await getAndSetupWarranties();
    const images = {};

    Object.values(document.getElementsByClassName('js--warranty-view-all')[0].attributes)
        .filter((k) => k.nodeName.indexOf('data-') !== -1)
        .forEach((k) => {
            images[k.nodeName.replace('data-', '').toUpperCase()] = k.value;
        });

    state.statuses = statusCodes;
    state.mfCodes = mfCodes;
    Object.keys(images).forEach((k) => (state.images[mfCodes[k]] = images[k]));

    cleanWarranties(warranties);
    console.log("attributes", document.getElementsByClassName('js--warranty-view-all')[0].attributes)
    console.log("images", images)

    console.log("mfCodes", mfCodes)
}

function setView() {
    let html = '';

    if (state.pagination.pageCount === 0) {
        html = `<button href="#" class="js--warranty-page list-grid__pagination__link list-grid__pagination--active" data-page="1">1</button>`;
    } else {
        for (let i = 1; i <= state.pagination.pageCount; i++) {
            html += `<button href="#" class="js--warranty-page list-grid__pagination__link ${i === 1 ? 'list-grid__pagination--active' : ''
                }" data-page="${i}">${i}</button>`;
        }
    }

    document.getElementsByClassName('js--pagination-pages')[0].innerHTML = html;
    document.getElementsByClassName('js--pagination-total')[0].innerHTML =
        state.pagination.resultCount;

    updateView();
    Array.from(document.getElementsByClassName('js--warranty-arrow')).forEach((k) =>
        k.addEventListener('click', () => handleArrowClick(k.getAttribute('data-action'))),
    );
}

// ==================================================
// UPDATERS
// ==================================================

async function updateView(page) {
    if (page) {
        const warranties = await getWarranties({ pageNumber: page, ...state.search });
        console.log("warranties", warranties);
        cleanWarranties(warranties);
    }

    const { pageNumber, pageSize, firstItemOnPage, lastItemOnPage } = state.pagination;

    updateArrows(pageNumber);

    document
        .getElementsByClassName('list-grid__pagination--active')[0]
        .classList.remove('list-grid__pagination--active');

    document
        .querySelector(`.js--warranty-page[data-page="${pageNumber}"]`)
        .classList.add('list-grid__pagination--active');

    document.getElementsByClassName('js--pagination-current')[0].innerHTML = pageSize;

    document.getElementsByClassName('js--warranty-viewall-list')[0].innerHTML = !state.warranties
        .length
        ? noItems()
        : state.warranties.map((k) => listItem(k)).join('');

    document.getElementsByClassName('js--pagination-current')[0].innerHTML =
        lastItemOnPage > 0 ? `${firstItemOnPage}-${lastItemOnPage}` : 0;

    Array.from(document.getElementsByClassName('js--warranty-item')).forEach((k) =>
        k.addEventListener('click', (e) => handleListItemClick(e)),
    );
}

function updateArrows(page) {
    const disabled = 'list-grid__pagination--disabled';
    const prevArrow = document.querySelector('.js--warranty-arrow[data-action="previous"]');
    const nextArrow = document.querySelector('.js--warranty-arrow[data-action="next"]');

    if (page === 1) {
        prevArrow.classList.add(disabled);
        prevArrow.setAttribute('readonly', 'readonly');
    } else if (page !== 1 && prevArrow.classList.contains(disabled)) {
        prevArrow.classList.remove(disabled);
        prevArrow.removeAttribute('readonly');
    }

    if (page >= state.pagination.pageCount) {
        nextArrow.classList.add(disabled);
        prevArrow.setAttribute('readonly', 'readonly');
    } else if (page !== state.pagination.pages && nextArrow.classList.contains(disabled)) {
        nextArrow.classList.remove(disabled);
        nextArrow.removeAttribute('readonly');
    }
}

// ==================================================
// HANDLERS
// ==================================================

function handleArrowClick(action) {
    const { pageNumber, pageCount } = state.pagination;
    const requestedPage = action === 'next' ? pageNumber + 1 : pageNumber - 1;

    if (
        (action === 'next' && requestedPage <= pageCount) ||
        (action === 'previous' && requestedPage >= 1)
    ) {
        updateView(requestedPage);
    }
}

function handleListItemClick(e) {
    const id = e.target.getAttribute('data-id')
        ? e.target.getAttribute('data-id')
        : e.target.closest('.js--warranty-item').getAttribute('data-id');

    window.location = `${url}?id=${id}`;
}

// ==================================================
// HELPERS
// ==================================================

const listItem = ({ ticketID, created, updated, status, brand, id }) => `<li>
  <a class="js--warranty-item list-grid__results__item list-grid__results--link" data-id="${id}">
    <div class="list-grid__results__li list-grid__results--center" data-label="Brand">
      <img src="${brand}" alt="">
    </div>
    <div class="list-grid__results__li list-grid__results--flex2" data-label="Ticket ID">${ticketID}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="Created">${created}</div>
    <div class="list-grid__results__li list-grid__results--center" data-label="Updated">${updated}</div>
    <div class="list-grid__results__li list-grid__results--flex2 list-grid__results--center" data-label="Status">${status}</div>
  </a>
</li>`;

const noItems = () => `<li>
  <div class="list-grid__results__item list-grid__results--link">No warranties available.</div>
</li>`;

function cleanWarranties(warranties) {
    const cleaned = [];

    warranties.data.forEach((k) => {
        cleaned.push({
            id: k.Id,
            brand: state.images[k.ManufacturerId],
            ticketID: k.TicketID,
            created: formatDate(k.CreatedDate),
            updated: formatDate(k.LastUpdatedDate),
            status: state.statuses[k.Status],
        });
    });

    state.warranties = cleaned;
    delete warranties.data;
    state.pagination = warranties;
    console.log("Manav", state.warranties)
}

// ==================================================
// SEARCH QUERY
// ==================================================

async function handleSearchQuery(e, reset = false) {
    e.preventDefault();

    const keywords = document.getElementById('list_keywords');
    const id = document.getElementById('list_brand');
    const clear = document.getElementsByClassName('js--list-clear')[0];

    state.search = {
        query: keywords.value,
        manufacturerId: state.mfCodes[id.value],
    };

    if (!state.search.query && !state.search.manufacturerId && !reset) {
        return;
    }

    keywords.value = '';
    id.value = '';

    const warranties = reset ? await getWarranties() : await getWarranties(state.search);
    cleanWarranties(warranties);
    setView();

    if (reset) {
        return clear.classList.add('list-grid__search--display-none');
    }

    clear.classList.remove('list-grid__search--display-none');
}

function toggleSearch() {
    document
        .getElementsByClassName('js--list-search-container')[0]
        .classList.toggle('list-grid__search--hidden');
}

// ==================================================
// INIT
// ==================================================

async function init() {
    await setState();
    setView();

    document.addEventListener('click', (e) =>
        hasClass(e.target, ['js--warranty-page'])
            ? updateView(e.target.getAttribute('data-page'))
            : false,
    );

    document
        .getElementsByClassName('js--list-search-toggle')[0]
        .addEventListener('click', toggleSearch);

    document
        .getElementsByClassName('js--list-submit')[0]
        .addEventListener('click', (e) => handleSearchQuery(e));

    document
        .getElementsByClassName('js--list-keywords')[0]
        .addEventListener('keyup', (e) => (e.keyCode === 13 ? handleSearchQuery(e) : false));

    document
        .getElementsByClassName('js--list-clear')[0]
        .addEventListener('click', (e) => handleSearchQuery(e, true));
}

export default init;
